module.exports = __webpack_public_path__ + "static/media/container.4c065709.svg";